<template>
    <div>
        <h1 style="text-align: center; margin-top: 20px;">Write your Solution</h1>

        <div class="ipad-complain">
            <canvas ref="canvas" class="drawing-canvas" @touchstart="startDrawing" @touchmove="draw" @touchend="stopDrawing"
                width="800" height="400"></canvas>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            drawing: false,
            canvas: null,
            context: null,
        };
    },
    mounted() {
        this.canvas = this.$refs.canvas;
        this.context = this.canvas.getContext('2d');
        this.context.lineWidth = 2;
        this.context.lineCap = 'round';
    },
    methods: {
        startDrawing(event) {
            this.drawing = true;
            const { clientX, clientY } = event.touches[0];
            const canvasRect = this.canvas.getBoundingClientRect();
            const offsetX = clientX - canvasRect.left;
            const offsetY = clientY - canvasRect.top;
            this.context.beginPath();
            this.context.moveTo(offsetX, offsetY);
        },
        draw(event) {
            if (!this.drawing) return;
            const { clientX, clientY } = event.touches[0];
            const canvasRect = this.canvas.getBoundingClientRect();
            const offsetX = clientX - canvasRect.left;
            const offsetY = clientY - canvasRect.top;
            this.context.lineTo(offsetX, offsetY);
            this.context.stroke();
        },
        stopDrawing() {
            this.drawing = false;
            const imageData = this.canvas.toDataURL();
            // Send the captured data to your server for processing with AI
        },
    },
};
</script>
  
<style scoped>
.ipad-complain {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: 50px;
}

.drawing-canvas {
    border: 2px solid #000;
    background-color: #fff;
    touch-action: none;
    /* Disable default touch gestures for better drawing experience */
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/IpadComplain.vue